import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

logoStyles.container = {
    css: css`
        display: flex;
        justify-content: center;
        margin: 0;
    `,
};

logoStyles.image = {
    css: css`
        max-width: 260px;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    max-width: 190px;
                `,
            ]);
        }}
    `,
};
